import moment from "moment";

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.04
 * @file : com/commFunc.js
 * @Desc : 날짜 포매팅 함수
 * @param {Date} date 포매팅할 날짜
 * @param {string} format 날짜포맷 ex. "yyyy-MM-DD"
 */
export const formatDate = (date, format) => {
  return moment(date).format(format);
};

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.04
 * @file : com/commFunc.js
 * @Desc : 현재년도+1 부터 최근 20개 년도 가져오기
 */
export const getCurYears = () => {
  const nowYear = new Date().getFullYear();
  const curYears = Array(20)
    .fill()
    .reduce((acc, _, idx) => {
      const year = nowYear - idx + 1;
      acc.push(year);
      return acc;
    }, []);

  return curYears;
};

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.08
 * @file : com/commFunc.js
 * @Desc : 연, 월, 일 더하기
 * @param {Date} date 포매팅 할 날짜 변수
 * @param {string} format 날짜포맷 ex. "yyyy-MM-DD"
 * @param {string} type 더할 날짜형식 "dates" | "weeks" | "months" | "years"
 */
export const addDate = (date, format, type) => {
  return moment(date).add(1, type).format(format);
};

/**
 *
 * @User : 백욱진
 * @Date : 2023.05.08
 * @file : com/commFunc.js
 * @Desc : 연, 월, 일 빼기
 * @param {Date} date 포매팅 할 날짜 변수
 * @param {string} format 날짜포맷 ex. "yyyy-MM-DD"
 * @param {string} type 뺄 날짜형식 "dates" | "weeks" | "months" | "years"
 */
export const subtractDate = (date, format, type) => {
  return moment(date).subtract(1, type).format(format);
};

/**
 *
 * @User : 이연우
 * @Date : 2023.05.09
 * @file : com/commFunc.js
 * @Desc : Select Option 포매팅 함수
 * @param {Array} data 포매팅 할 데이터
 * @param {string} label 라벨에 넣을 key명
 * @param {string} value 값에 넣을 key명
 */
export const formatSelect = (data, label, value) => {
  const options = data.map((data) => {
    return { label: data[label], value: data[value] };
  });
  return options;
};

/**
 *
 * @User : 이연우
 * @Date : 2023.05.30
 * @file : script/commFunc.js
 * @Desc : 숫자 포매팅 함수 (세자리 마다 콤마)
 * @param {number} num 포매팅 할 데이터
 */
export const numberWithCommas = (num ) => {
  if (!num || num === "") {
    return "0";
  }
  if (typeof num === "number") {
    num = num.toString();
  }
  return  num.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  
};

/**
 *
 * @User : 이연우
 * @Date : 2023.06.26
 * @file : script/commFunc.js
 * @Desc : 숫자 포매팅 함수
 * @param {string} str 포매팅 할 데이터
 */
export const StrToNum = (str) => {
  if (!str) {
    return 0;
  }

  if (typeof str === "number") {
    return str;
  }

  const num = Number(str.replace(/[^0-9.]/g, ""));

  return num;
};

/**
 * @User : 이연우
 * @Date : 2023.06.19
 * @file : script/checkValidate.js
 * @Desc : params 빈 값 확인
 * @param params <object> 검사할 요소들
 * @param exceptedIdArray <Array> 예외 ID
 * @param dateIdArray <Array> 날짜 ID
 * @returns boolean
 */
export const checkValidate = (params, exceptedIdArray, dateIdArray) => {
  const dateId = [
    "yearMonthDay",
    "yearMon",
    "yearMonFrom",
    "yearMonTo",
    "year",
    "perfStDt",
    "perfEdDt",
    ...(dateIdArray || []),
  ];

  const paramsId = Object.keys(params).filter(
    (param) => !exceptedIdArray?.includes(param)
  );
  return paramsId.reduce((acc, cur) => {
    if (dateId?.includes(cur)) {
      let date = params[cur]?.toString().replace(/[^0-9]/g, "");

      if (!date) {
        return false;
      }
      if (!(date.length === 8 || date.length === 6)) {
        return false;
      }

      let rxDatePattern;
      if (date.length === 8) {
        rxDatePattern = /^(\d{4})(\d{1,2})(\d{1,2})$/;
      } else if (date.length === 6) {
        rxDatePattern = /^(\d{4})(\d{1,2})$/;
      }

      const dtArray = date.match(rxDatePattern);
      if (dtArray === null) {
        return false;
      }

      const dtYear = dtArray[1];
      const dtMonth = dtArray[2];
      const dtDay = dtArray[3] || 1;

      if (dtMonth < 1 || dtMonth > 12) {
        return false;
      } else if (dtDay < 1 || dtDay > 31) {
        return false;
      } else if (
        (dtMonth === 4 || dtMonth === 6 || dtMonth === 9 || dtMonth === 11) &&
        dtDay === 31
      ) {
        return false;
      } else if (dtMonth === 2) {
        const isleap =
          dtYear % 4 === 0 && (dtYear % 100 !== 0 || dtYear % 400 === 0);
        if (dtDay > 29 || (dtDay === 29 && !isleap)) {
          return false;
        }
      }
      return acc && true;
    } else {
      return acc && !!params[cur];
    }
  }, true);
};

/**
 * @User : 이연우
 * @Date : 2023.07.14
 * @file : script/checkValidate.js
 * @Desc : classname = 'checkValidate' 또는 essential인 element의 빈 값 확인
 * @param wrapperId <String> value 요소들을 wrapping 한 Element ID
 * @returns boolean
 */
export const checkCompsValidate = (wrapperId) => {
    const elements = document.getElementById(wrapperId).querySelectorAll(['input', 'textarea', 'select']);
    // commSelect element ex) 광고주, 광고회사
    const className = document.getElementById(wrapperId).getElementsByClassName('checkValidate')

    // commSelect element val 체크
    for (let i = 0; i < className.length; i++){
        const el = className[i];
        const essential = el.className.includes('essential')
        
        if(essential){
            if(!el.innerText.trim()){
                alert(`${el.id}을 입력해 주세요.`);
                return false;
            }
        }
    }

    for (let i = 0; i < elements.length; i++){
        const el = elements[i];
        const essential = el.className.includes('essential')

        if(essential){
            switch(el.type){
                case "radio": case "checkbox": 
                    break;
                default: 
                    if(!el.value.trim()){
                        alert(`${el.name}을 입력해 주세요.`);
                        return false;
                    }
            }
        }
    }
    return true;
};

/**
 *
 * @User : 이연우
 * @Date : 2023.06.29
 * @file : script/commFunc.js
 * @Desc : 날짜 차이 계산
 * @param {string} perfStDt 시작 날짜
 * @param {string} perfEdDt 끝 날짜
 */
export const DateDiff = (perfStDt, perfEdDt) => {
  return Math.abs(moment(perfStDt) - moment(perfEdDt)) / (1000 * 60 * 60 * 24);
};

/**
 *
 * @User : 백욱진
 * @Date : 2023.07.07
 * @file : script/commFunc.js
 * @Desc : 소재의 초수/비율로 계산한 목표시청자수
 * @param {number} budgAmt 예산
 * @param {number} cpm 단가
 * @param {number} sec 초수
 * @param {number} value 백분율
 */
export const getTargetViewer = (budgAmt, cpm, sec, value) => {
  const targetView =
    //(budgAmt * (value / 100) * 1000) / (cpm * (parseInt(sec) / 15));
      (budgAmt * (value / 100) * 1000) / (cpm);
  return Math.ceil(targetView);
};

/**
 *
 * @User : 이연우
 * @Date : 2023.07.07
 * @file : script/commFunc.js
 * @Desc : 소재의 초수/비율로 계산한 예산
 * @param {number} targetView 목표시청자수
 * @param {number} cpm 단가
 * @param {number} sec 초수
 * @param {number} value 백분율
 */
export const getBudgAmt = (targetView, cpm, sec, value) => {
  const budgAmt =
    (targetView * cpm * (parseInt(sec) / 15)) / ((value / 100) * 1000);
  return Math.floor(budgAmt);
};

/**
 *
 * @User : 이연우
 * @Date : 2023.07.13
 * @file : script/commFunc.js
 * @Desc : 소재의 초수/비율로 계산한 예산
 * @param {number} budgAmt 예산
 * @param {number} targetView 목표시청자수
 */
export const getCPM = (budgAmt, targetView) => {
  const cpm = (budgAmt / targetView * 1000)
  return Math.round(cpm);
};

/**
 *
 * @Desc : 소재의 초수/비율로 계산한  GRP
 * @param {number} budgAmt 예산
 * @param {number} cpm 단가
 * @param {number} sec 초수
 * @param {number} value 백분율
 * @param {number} tgPopCnt 전체 모수
 *
 */

export const getTargetGrp = (budgAmt = 0 , cpm, sec, value, tgPopCnt  = 0  ) => {

    budgAmt  = Number(budgAmt ?? 0 )
    tgPopCnt  = Number(tgPopCnt ?? 0 )
    if(budgAmt === 0 || tgPopCnt  === 0 ) return  0 ;

    const _tgViewer = getTargetViewer (budgAmt, cpm, sec, value)    ;
    const targetGrp  = ((_tgViewer/ tgPopCnt) *100).toFixed(2);

    return targetGrp;
};

/**
 * @Desc : 소재의 초수/비율로 계산한 CPRP
 * @param {number} budgAmt 예산
 * @param {number} cpm 단가
 * @param {number} sec 초수
 * @param {number} value 백분율
 * @param {number} tgPopCnt 전체 모수
 */
export const getTargetCprp  = (budgAmt = 0 , cpm, sec, value, tgPopCnt  = 0  ) => {
    budgAmt  = Number(budgAmt ?? 0 )
    tgPopCnt  = Number(tgPopCnt ?? 0 )
    if(budgAmt === 0 || tgPopCnt  === 0 ) return  0 ;

    const  _grp = getTargetGrp(budgAmt, cpm, sec, value, tgPopCnt  )   ;
    if(_grp === 0 ) return  0 ;

    const cprp =  Math.floor(budgAmt /_grp )    ;
    return Math.round(cprp);
};

/**
 *
 * @Desc :  계약구분에 따른 시청자수  또는 GRP
 * @param {number} budgAmt 예산
 * @param {number} cpm 단가
 * @param {number} sec 초수
 * @param {number} value 백분율
 * @param {number} tgPopCnt 전체 모수
 * @param {number} prcDivCd  계약구분
 *
 */
export const getTargetValue = (budgAmt = 0 , cpm, sec, value, tgPopCnt  = 0 , perfReqTypeCd ='SNP03' ) => {
    return  (perfReqTypeCd === "SNP03" || perfReqTypeCd === "SNP07" ) ?  getTargetViewer( budgAmt, cpm, sec, value) :  getTargetGrp(budgAmt, cpm, sec, value, tgPopCnt)   ;
};


/**
 *
 * @Desc : 시청자, 모수로 GRP 계산
 * @param {number} tgViewer 시청자수
 * @param {number} tgPopCnt 전체 모수
 *
 */
export const getGrp = ( tgViewer  = 0  , tgPopCnt  = 0  ) => {
    tgViewer  = Number(tgViewer ?? 0 )
    tgPopCnt  = Number(tgPopCnt ?? 0 )
    if(tgViewer === 0 || tgPopCnt  === 0 ) return  0 ;

    return  ((tgViewer/ tgPopCnt) *100).toFixed(2);
};


export const geKoreanNumber = ( number  = 0   ) => {

    const textArray = ["", "일", "이", "삼", "사","오","육","칠","팔","구","십"];
    const priceArray = ["", "십", "백", "천", "", "십", "백", "천", "", "십", "백", "천", "", "십", "백", "천"];

    const enteredNumber = (number).toString(); // 만원 단위로 입력받기 때문에 * 10000
    const numberArray = enteredNumber.split(""); //number 를 배열로 변환
    let result = ""; // 리턴값 선언

    numberArray.forEach((item, index) => {
        let numberUnit = "";
        let transNumber =  textArray[enteredNumber.charAt(numberArray.length - (index + 1))] ; //숫자를 해당 자리에 맞는 한글로 변환

        if (transNumber !== "") {
            numberUnit += transNumber + priceArray[index]; // 변환한 숫자가 존재할경우 자릿수를 붙여줍니다.
        }
        //단위 붙여주기
        switch (index) {
            case 4:
                numberUnit += "만";
                break;
            case 8:
                numberUnit += "억";
                break;
            case 12:
                numberUnit += "조";
                break;
            default  :
                break ;
        }
        // numberUnit이 존재할때 리턴값에 numberUnit을 더해줌
        if (numberUnit !== "") {
            result = numberUnit + result;
        }
    });

    //0만을 사용해 억단위로 올라갈 때에 '만' 을 제거해준다
    const zeroCount = numberArray.filter((item) => item === "0").length;
    if (zeroCount === 8) {
        result = result.replace("만", "");
    }
    return result;
};

export const strToDate = (date, time ) => {
    let _date = ""  ;
    try{
        if(time.substring(0,2) >= 24 ){
            _date =  moment(date +" " + String( Number(time)-2400).padStart(4, "0") ).add(1, 'days').toDate()
        } else{
            _date =  moment(date +" " + time).toDate()
        }
    }catch (e) {
    }
    return _date ;
  
};

